import { render, staticRenderFns } from "./ExtendCandidate.vue?vue&type=template&id=0b421237"
import script from "./ExtendCandidate.vue?vue&type=script&lang=js"
export * from "./ExtendCandidate.vue?vue&type=script&lang=js"
import style0 from "./ExtendCandidate.vue?vue&type=style&index=0&id=0b421237&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports